
import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "../utils/cn";

/**
 * @typedef {Object} SeparatorProps
 * @property {string} [className]
 * @property {"horizontal" | "vertical"} [orientation]
 * @property {boolean} [decorative]
 * @property {any} [props] - Any additional props passed to Radix Separator
 */

/**
 * Separator component (JS version with JSDoc types)
 * @param {SeparatorProps & React.ComponentProps<typeof SeparatorPrimitive.Root>} param0
 */
function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className
      )}
      {...props}
    />
  )
}

export { Separator }
